export const LineRightIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="54"
            height="1"
            viewBox="0 0 54 1"
            fill="none"
        >
            <path d="M53.0337 0.5H0.533691" stroke="url(#paint0_linear_4433_20555)" />
            <defs>
                <linearGradient
                    id="paint0_linear_4433_20555"
                    x1="-1.3149"
                    y1="0.999935"
                    x2="53.4136"
                    y2="0.179648"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#E53223" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
